export const MONTH_FORMAT = 'MMM';
export const MONTH_FULL_FORMAT = 'MMMM';
export const DAY_FORMAT = 'DD';
export const FULL_YEAR_FORMAT = 'YYYY';
export const DMY_DATE_FORMAT = 'DD/MM/YYYY';
export const YMD_DATE_FORMAT = 'YYYY-MM-DD';
